export interface SiteDataProps {
  name: string;
  title: string;
  description: string;
  supportEmail: string;
  url: string;
  installUrl: string;
}

const siteData: SiteDataProps = {
  name: "SendKit",
  title: "SendKit",
  description:
    "SendKit is a tool that streamlines sending newsletters to customers.",
  supportEmail: "support@send-kit.com",
  url: "https://send-kit.com",
  installUrl: "https://apps.shopify.com/sendkit-email",
};

export default siteData;
